import { AUAnalyticsUtils } from '@assertiva/assertiva-ui';
import { IGAEvent } from '@assertiva/assertiva-ui/core/utils/analytics.v2';

export const sendInternalAnalytics = (event: Partial<IGAEvent>) =>
  AUAnalyticsUtils.sendAnalytics(event, true, true);

export const sendAnalytics = (event: Partial<IGAEvent>) =>
  AUAnalyticsUtils.sendAnalytics(event);
